import { useCallback, useEffect, useState } from "react";
import { ExternalLink, MapPin, Pencil, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Empty, Field, Loading, PageHeader, Panel } from "../components/common";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

const EMPTY = { nome: "", url: "", note: "" };

export default function Luoghi() {
  const [items, setItems] = useState(null);
  const [edit, setEdit] = useState(null);
  const load = useCallback(() => api("/web/luoghi").then((d) => setItems(d.luoghi)).catch((e) => { toast.error(e.message); setItems([]); }), []);
  useEffect(() => { load(); }, [load]);
  const save = async () => {
    if (!edit.nome.trim() || !/^https:\/\//.test(edit.url.trim())) return toast.error("Inserisci un nome e un link che inizia con https://");
    const body = { nome: edit.nome.trim(), url: edit.url.trim(), note: edit.note || "" };
    try { await api(edit.id ? `/web/luoghi/${edit.id}` : "/web/luoghi", { method: edit.id ? "PUT" : "POST", body }); toast.success("Luogo salvato"); setEdit(null); load(); } catch (e) { toast.error(e.message); }
  };
  const del = async (l) => {
    if (!window.confirm(`Eliminare "${l.nome}"?`)) return;
    try { await api(`/web/luoghi/${l.id}`, { method: "DELETE" }); toast.success("Luogo eliminato"); load(); } catch (e) { toast.error(e.message); }
  };
  if (items === null) return <Loading />;
  return (
    <div>
      <PageHeader subtitle="Pannello Direttore" title="Luoghi utili" actions={<Button onClick={() => setEdit({ ...EMPTY })} className="rounded-full bg-[var(--navy)]" data-testid="luoghi-add"><Plus className="w-4 h-4 mr-1" />Aggiungi luogo</Button>} />
      {items.length === 0 ? <Empty title="Nessun luogo" text="Aggiungi un luogo con il suo link di Google Maps." /> : (
        <Panel className="!p-0" data-testid="luoghi-list">{items.map((l) => (
          <div key={l.id} className="flex items-center gap-4 px-5 py-4 border-b last:border-0" data-testid={`luogo-${l.id}`}>
            <span className="w-10 h-10 rounded-xl bg-[var(--teal-soft)] flex items-center justify-center shrink-0"><MapPin className="w-5 h-5 text-[var(--teal)]" /></span>
            <div className="flex-1 min-w-0">
              <a href={l.url} target="_blank" rel="noreferrer" className="font-semibold text-[var(--navy)] hover:text-[var(--teal)] flex items-center gap-1" data-testid={`luogo-link-${l.id}`}>{l.nome}<ExternalLink className="w-3.5 h-3.5" /></a>
              <p className="text-xs text-slate-500 truncate">{l.note || l.url}</p>
            </div>
            <Button size="icon" variant="ghost" onClick={() => setEdit({ ...l })} data-testid={`luogo-edit-${l.id}`}><Pencil className="w-4 h-4" /></Button>
            <Button size="icon" variant="ghost" onClick={() => del(l)} data-testid={`luogo-delete-${l.id}`}><Trash2 className="w-4 h-4 text-[var(--red)]" /></Button>
          </div>))}
        </Panel>)}
      <Dialog open={!!edit} onOpenChange={() => setEdit(null)}>
        <DialogContent>
          <DialogHeader><DialogTitle>{edit?.id ? "Modifica luogo" : "Nuovo luogo"}</DialogTitle></DialogHeader>
          {edit && <div className="space-y-3">
            <Field label="Nome"><Input value={edit.nome} onChange={(e) => setEdit({ ...edit, nome: e.target.value })} data-testid="luogo-nome" /></Field>
            <Field label="Link Google Maps"><Input value={edit.url} onChange={(e) => setEdit({ ...edit, url: e.target.value })} placeholder="https://maps.app.goo.gl/..." data-testid="luogo-url" /></Field>
            <Field label="Note (facoltative)"><Input value={edit.note} onChange={(e) => setEdit({ ...edit, note: e.target.value })} data-testid="luogo-note" /></Field>
            <Button onClick={save} className="rounded-full bg-[var(--navy)]" data-testid="luogo-save">Salva</Button>
          </div>}
        </DialogContent>
      </Dialog>
    </div>
  );
}
